import { render, staticRenderFns } from "./carouselDetails.vue?vue&type=template&id=0f760262&scoped=true"
import script from "./carouselDetails.vue?vue&type=script&lang=js"
export * from "./carouselDetails.vue?vue&type=script&lang=js"
import style0 from "./carouselDetails.vue?vue&type=style&index=0&id=0f760262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f760262",
  null
  
)

export default component.exports